import React from 'react';

import Block from '../../blocks/Block';
import Breadcrumbs from '../../breadcrumbs/Breadcrumbs';
import Layout from '../../layout';
import TitleWrapper from './TitleWrapper';

import './BlocksOnly.scss';

const BlocksOnly = ({ data }) => {
  const {
    page: {
      title,
      templateFields: { blocks, blocksOnlyFields },
    },
  } = data;
  const { shouldDisplayTitle, breadcrumbs } = blocksOnlyFields;

  const defaultTitleWrapper = <TitleWrapper {...blocksOnlyFields} title={title} />;

  let pageHeading = defaultTitleWrapper;
  if (breadcrumbs) {
    const [breadcrumbsData] = breadcrumbs;
    if (breadcrumbsData?.includeBreadcrumbs) {
      pageHeading = <Breadcrumbs breadcrumbs={breadcrumbsData?.breadcrumbsGroup}>{defaultTitleWrapper}</Breadcrumbs>;
    }
  }

  return (
    <Layout className="BlocksOnly">
      {shouldDisplayTitle && pageHeading}
      <div>
        {blocks?.map((block, index) => (
          <Block data={block} key={index} />
        ))}
      </div>
    </Layout>
  );
};

export default BlocksOnly;
